import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import './header.scss';
import Tracker from '../../../../Page/SelfCarePage/partials/header/tracker/tracker';
import TrackerExpanded from '../../../../Page/SelfCarePage/partials/header/tracker/trackerExpanded';
import PopUp from '../../../../Shared/Popup/PopUp';
import { isMobile } from 'react-device-detect';
import { handleURL, buildUrlAndOpenSameWindow } from '../../../../../utilities/StringHelpers/StringHelpers';
import { getTrackerItems} from '../../../../Page/SelfCarePage/SelfCareAsyncThunk';
import { displayPopUp } from '../../../../Page/SelfCarePage/SelfCareSlice';
import Image from 'app/Components/Shared/Image/image';
import rightIcon from './images/right.svg';
import Config from 'app/Config';

const Header = (props) => {
  const [firstName, setFirstName] = useState('');

  useEffect(() => {
    if(props._authentication?.isAuthenticateFinish){
      const userDetails = props._authentication?.loginData?.userDetails;
      const firstName = userDetails?.firstName?.trim() || userDetails?.contactNumber || '';      
      setFirstName(firstName);
      props.getTrackerItems();
    }
  }, [props._authentication?.isAuthenticateFinish]);

  const closeModal = () => {
    props.displayPopUp(false);
  };

  const navigateToPage = (url) => {
    handleURL(url, props.context);
  };

  const epiBaseUrl = Config?.epiBaseUrl ?? '';
  const backgroundImageDesktop = props.blockData?.backgroundImageDesktop ;
  const backgroundImageMobile = props.blockData?.backgroundImageMobile ;
  const headerBackgroundImage = isMobile ? backgroundImageMobile : backgroundImageDesktop;
  const headerBackgroundImageUrl = headerBackgroundImage
    ? `${epiBaseUrl}${headerBackgroundImage}`
    : null;

  const trackerCount =
    props._selfCareSliceTracker?.numOfItems ??
    props._selfCareSliceTracker?.orderedTrackerItems?.length ??
    0;

  const getXhtmlValue = (xhtmlField) => {
    if (!xhtmlField) {
      return '';
    }

    if (typeof xhtmlField === 'string') {
      return xhtmlField;
    }

    return xhtmlField?.value ?? '';
  };

  const subtitleText = trackerCount > 1
    ? getXhtmlValue(props.blockData?.subTitleMoreThenOneMessage)
    : trackerCount === 1
    ? getXhtmlValue(props.blockData?.subTitleOneMessage)
    : getXhtmlValue(props.blockData?.subTitleNoMessage);

  const headerClassName = `operations-areas-header ${!headerBackgroundImageUrl ? 'no-background-image' : ''} ${trackerCount > 0 ? 'has-tracker' : ''}`.trim();

  return (
    <div className={headerClassName}>
      <div className='header-background-image-container'>
        {headerBackgroundImageUrl && <img className='header-background-image' src={headerBackgroundImageUrl} alt='header background' />}
      </div>
      <div className='header-content'>
        <div className='title-wrapper'>
          <h1 className='title'>היי {firstName},</h1>
          <h1 className='sub-title' dangerouslySetInnerHTML={{__html: subtitleText}}></h1>
        </div>
        <div className='tracker-swiper-container'>
          {isMobile && props._selfCareSliceTracker?.showPopUp && (
            <TrackerExpanded
              popUpType={props._selfCareSliceTracker?.popUpType}
              {...props._selfCareSliceTracker?.popUpProps}
              context={props.context}
              urlToAbroad={props._startPage?.selfCareTracker?.expandedValue?.[0]?.pageRefToMyAbroadPackage?.value}
              navigateToPage={navigateToPage}
              contentData={props._startPage?.selfCareTracker?.expandedValue?.[0]}
              closePage={closeModal}
              handleIdPopup={buildUrlAndOpenSameWindow}
            />
          )}
          {!isMobile && (
            <PopUp onClose={closeModal} showPopUp={props._selfCareSliceTracker?.showPopUp}>
              <TrackerExpanded
                popUpType={props._selfCareSliceTracker?.popUpType}
                {...props._selfCareSliceTracker?.popUpProps}
                context={props.context}
                urlToAbroad={props._startPage?.selfCareTracker?.expandedValue?.[0]?.pageRefToMyAbroadPackage?.value}
                navigateToPage={navigateToPage}
                contentData={props._startPage?.selfCareTracker?.expandedValue?.[0]}
                closePage={closeModal}
                handleIdPopup={buildUrlAndOpenSameWindow}
              />
            </PopUp>
          )}
          <div className='user-info-container'>
            <div className='tracker-main-wrapper'>
              <Tracker epiData={props._startPage?.selfCareTracker?.expandedValue?.[0]} context={props.context} />
            </div>
          </div>
        </div>
      </div>
      <button className='back-button' onClick={() => window.history.back()}>
        <Image src={rightIcon} alt='חזרה' />
        <span>חזרה</span>
      </button>
    </div>
  );

};

const mapStateToProps = (state) => {
  return {
    blockData: state.operationsAreasBlock?.blockData,

    _startPage: state.iContentRepo.items?.[state.iContentRepo.website.contentRoots.startPage.id]?.content,
    _authentication: state.authentication,
    _selfCareSliceTracker: state.selfcarePage?.selfCareData?.trackers,
  };
};

const mapDispatchToProps = {
  getTrackerItems,
  displayPopUp,
};

export default connect(mapStateToProps, mapDispatchToProps)(Header);
